(function () {
  'use strict';

  /*
    JavaScriptが有効な場合のみ
    アニメーション用CSSを有効化
  */
  document.documentElement.classList.add('js-enabled');


  /*
    root自身と、root内部の対象要素をまとめて取得
  */
  function getElements(root, selector) {
    var elements = [];

    if (
      root instanceof Element &&
      root.matches(selector)
    ) {
      elements.push(root);
    }

    if (root.querySelectorAll) {
      elements = elements.concat(
        Array.prototype.slice.call(
          root.querySelectorAll(selector)
        )
      );
    }

    return elements;
  }


  /*
    data-fade-staggerを指定した親要素内で、
    子要素へ順番に遅延時間を設定
  */
  function setFadeStagger(root) {
    var groups = getElements(
      root,
      '[data-fade-stagger]'
    );

    groups.forEach(function (group) {
      var stagger = parseInt(
        group.getAttribute('data-fade-stagger'),
        10
      );

      if (isNaN(stagger)) {
        stagger = 0;
      }

      var targets = group.querySelectorAll(
        '.js-fadeup'
      );

      targets.forEach(function (target, index) {
        /*
          data-fade-delayがある場合は、
          個別設定を優先
        */
        var customDelay = target.getAttribute(
          'data-fade-delay'
        );

        var delay;

        if (customDelay !== null) {
          delay = parseInt(customDelay, 10);
        } else {
          delay = stagger * index;
        }

        if (isNaN(delay)) {
          delay = 0;
        }

        target.style.setProperty(
          '--fade-delay',
          Math.max(0, delay) + 'ms'
        );
      });
    });
  }


  /*
    アニメーションを減らす設定
  */
  var reduceMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;


  /*
    IntersectionObserver
  */
  var fadeObserver = null;

  if (
    'IntersectionObserver' in window &&
    !reduceMotion
  ) {
    fadeObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            return;
          }

          entry.target.classList.add('is-show');

          fadeObserver.unobserve(entry.target);
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -10% 0px',
        threshold: 0.15
      }
    );
  }


  /*
    フェードアップ初期化
  */
  function initFadeUp(root) {
    var scope = root || document;

    setFadeStagger(scope);

    var targets = getElements(
      scope,
      '.js-fadeup'
    );

    targets.forEach(function (target) {
      /*
        二重初期化を防止
      */
      if (
        target.getAttribute(
          'data-fade-initialized'
        ) === 'true'
      ) {
        return;
      }

      target.setAttribute(
        'data-fade-initialized',
        'true'
      );

      /*
        Observer非対応、または動きを減らす設定なら
        そのまま表示
      */
      if (!fadeObserver) {
        target.classList.add('is-show');
        return;
      }

      fadeObserver.observe(target);
    });
  }


  /*
    通常のページ読み込み
  */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initFadeUp(document);
      }
    );
  } else {
    initFadeUp(document);
  }


  /*
    Shopifyテーマエディターで
    セクションが再読み込みされた場合
  */
  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initFadeUp(event.target);
    }
  );

})();